import {
  InventoryFormDetails,
  InventoryReportStatusEnum,
  Report,
} from 'types/report';
import * as yup from 'yup';

import { toFeeRows } from 'constants/feeAdjustments';

export const getInitialValues = (report: Report | null) => ({
  notes: report?.notes || '',
  invoiceNotes: report?.invoiceNotes || '',
  cokeAdjustment: report?.cokeAdjustment || 0,
  feeAdjustment: report?.feeAdjustment || 0,
  feeAdjustments: toFeeRows(report?.feeAdjustments, report?.feeAdjustment),
  reportReady:
    Number(report?.status) === InventoryReportStatusEnum.IN_REVIEW
      ? false
      : true, // This variable is not to be initialised for statuses other than IN_REVIEW
  isSentToClient: report?.isSentToClient !== false,
});

const detailSchema = yup.object().shape({
  beg: yup.number().required('Beginning is required'),
  del: yup.number().required('Del is required'),
  end: yup.number().required('End is required'),
  ret: yup.number().required('Ret is required'),
  unu: yup.number().required('Unu is required'),
});

export const validationSchema = yup.object().shape({
  notes: yup.string(),
  invoiceNotes: yup.string(),
  reportReady: yup.boolean().nullable(),
  cokeAdjustment: yup.number().nullable(),
  feeAdjustment: yup.number().nullable(),
  feeAdjustments: yup
    .array()
    .of(
      yup.object().shape({
        type: yup.string().required(),
        amount: yup.number().required(),
      }),
    )
    .nullable(),
  isSentToClient: yup.boolean().nullable(),
});
